import { createContext, use } from "react"

import type { Point } from "../../shared/types"
import type { Frame } from "../types/Frame"
import type { Options } from "../types/Options"
import type { ResolvedResampling } from "../types/Resampling"
import type { Source } from "../types/Source"

export interface CursorData {
  source: Source | null
  isLoading: boolean
  loadError: string | null
  isConverting: boolean
  options: Options
  // The source's frames as the options show and upload them.
  outputFrames: Frame[]
  // How the output frames were scaled, Auto resolved; the upload scales its smaller sizes the same way.
  outputResampling: ResolvedResampling
  // Where Auto puts the hotspot on the first output frame.
  autoHotspot: Point
  handleNewSource: (files: File[]) => Promise<void>
  // Takes the frames as shown; the edit lands on the source frames they were made from.
  setFrames: (frames: Frame[]) => void
  addFrames: (frames: Frame[]) => void
  changeOptions: (options: Options) => void
  setHotspot: (hotspot: Point) => void
  // Drops the loader's suggestion for an option, so its notice stays away until the next source.
  dismissSuggestion: (option: keyof Options) => void
  clearLoadError: () => void
  setIsConverting: (isConverting: boolean) => void
}

export const CursorDataContext = createContext<CursorData | null>(null)

export const useCursorData = () => {
  const data = use(CursorDataContext)
  if (!data) throw new Error("useCursorData needs a CursorDataProvider above it")

  return data
}
